export default {
  common: {
    search: 'Search',
    reset: 'Reset',
    save: 'Save',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    add: 'Add',
    edit: 'Edit',
    back: 'Back',
    export: 'Export',
    import: 'Import',
    enable: 'Enable',
    disable: 'Disable',
    operation: 'Operation',
    status: 'Status',
    detail: 'Detail',
    view: 'View',
    copy: 'Copy',
    close: 'Close',
    submit: 'Submit',
    download: 'Download',
    upload: 'Upload',
    refresh: 'Refresh',
    loading: 'Loading...',
    noData: 'No Data',
    success: 'Success',
    failed: 'Failed',
    confirmDelete: 'Confirm Delete',
    confirmDeleteContent: 'Are you sure you want to delete?',
    ok: 'OK',
    total: 'Total {total} items',
    selectPlaceholder: 'Please select',
    inputPlaceholder: 'Please enter',
    startTime: 'Start Time',
    endTime: 'End Time',
    today: 'Today',
    yesterday: 'Yesterday',
    week: 'This Week',
    month: 'This Month',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    enabled: 'Enabled',
    disabled: 'Disabled',
    id: 'ID',
    createTime: 'Created At',
    updateTime: 'Updated At',
    actions: 'Actions',
    saveConfig: 'Save Config',
    batchEdit: 'Batch Edit',
    viewMore: 'View More',
    imageOnly: 'Please upload image files only! Please delete the current file manually.',
    uploadFileSizeLimit: 'Upload file size cannot exceed 10MB! Please delete the current file manually.'
  },
  menu: {
    workplace: 'Dashboard',
    peiwan: 'My Orders',
    'peiwan-companion': 'Companion Orders',
    personal: 'Profile',
    menu: 'Menu Mgmt',
    client: 'Client Mgmt',
    user: 'User Mgmt',
    withdraw: 'Withdrawals',
    dailian: 'Boosting Orders',
    gift: 'Gift Orders',
    dict: 'Dictionary',
    rankList: 'Rankings',
    registerReview: 'Registration Review',
    orderReview: 'Order Review',
    peiwanReview: 'Companion Review',
    dailianReview: 'Boosting Review',
    giftReview: 'Gift Review',
    role: 'Role Mgmt',
    log: 'Log Mgmt',
    aftersale: 'After-Sales',
    shopConfig: 'Shop Config',
    downloadCenter: 'Download Center',
    billing: 'Billing'
  },
  header: {
    personalCenter: 'Profile',
    settings: 'Settings',
    logout: 'Logout'
  },
  login: {
    title: 'catkiller gaming Admin',
    welcome: 'Welcome Back',
    username: 'Username',
    password: 'Password',
    rememberMe: 'Remember me',
    register: 'Register',
    login: 'Login',
    placeholder: {
      username: 'Enter username or email',
      password: 'Enter password'
    }
  },
  register: {
    adminPanel: 'Admin Panel',
    title: 'User Registration',
    hasAccount: 'Already have an account?',
    loginNow: 'Login Now',
    step: {
      basic: 'Basic Info',
      identity: 'Identity Info'
    },
    form: {
      username: 'Username/Account',
      password: 'Password',
      nickname: 'Nickname',
      role: 'Order Role',
      phone: 'Phone',
      wechat: 'WeChat',
      realName: 'Real Name',
      idCard: 'ID Card',
      alipay: 'Alipay',
      address: 'Address',
      passCode: 'Pass Code'
    },
    placeholder: {
      username: 'Enter username/account',
      password: 'Enter password',
      nickname: 'Enter nickname',
      phone: 'Enter phone number',
      wechat: 'Enter WeChat ID',
      realName: 'Enter real name',
      idCard: 'Enter ID card number',
      alipay: 'Enter Alipay account',
      address: 'Enter address',
      passCode: 'Enter pass code (staff only)'
    },
    role: {
      companion: 'Companion',
      booster: 'Booster'
    },
    next: 'Next',
    prev: 'Back',
    submit: 'Submit Registration',
    success: 'Registration submitted! Awaiting admin approval...'
  },
  workplace: {
    overview: 'Dashboard Overview',
    greeting: {
      morning: 'Good morning',
      afternoon: 'Good afternoon',
      evening: 'Good evening',
      welcome: 'Welcome back'
    },
    stats: {
      companion: 'Companions',
      companionTip: 'Total users with companion role (Role ID=1)',
      booster: 'Boosters',
      boosterTip: 'Total users with booster role (Role ID=2)',
      revenue: 'Revenue',
      revenueTip: 'Total amount of valid orders (approved and later), excluding pending, cancelled, and rejected'
    },
    metrics: {
      todayRevenue: 'Today Revenue',
      todayRevenueTip: 'Total amount of valid orders created today (excluding pending, cancelled, rejected), compared with yesterday',
      todayOrders: 'Today Orders',
      todayOrdersTip: 'Total valid orders created today (excluding pending, cancelled, rejected), compared with yesterday',
      todayNewUsers: 'New Users Today',
      todayNewUsersTip: 'Number of companion/booster users registered today, compared with yesterday',
      todayNewCustomers: 'New Customers Today',
      todayNewCustomersTip: 'Number of customers created today, compared with yesterday'
    },
    adminMetrics: {
      customerBalance: 'Total Customer Balance',
      customerBalanceTip: 'Sum of all customer balances',
      customerReward: 'Total Cost Amount',
      customerRewardTip: 'Total customer recharge (gift) transaction amount',
      pendingOrderAmount: 'Pending Review Order Amount',
      pendingOrderAmountTip: 'Total amount of orders with order_status=0 (pending review)',
      pendingOrderCount: 'Pending Review Order Count',
      pendingOrderCountTip: 'Total count of orders with order_status=0 (pending review)',
      approvedOrderAmount: 'Approved Order Amount (Not Withdrawn)',
      approvedOrderAmountTip: 'Total amount of orders with order_status IN (3,4) (approved + pending withdrawal)',
      approvedOrderCount: 'Approved Order Count',
      approvedOrderCountTip: 'Total count of orders with order_status IN (3,4)',
      pendingSalaryAmount: 'Pending Salary Amount (Withdrawal Requested)',
      pendingSalaryAmountTip: 'Total amount of orders with order_status=5 (withdrawal reviewing)',
      pendingSalaryCount: 'Pending Salary Order Count',
      pendingSalaryCountTip: 'Total count of orders with order_status=5 (withdrawal reviewing)'
    }
  },
  shopConfig: {
    tabs: {
      commissionConfig: 'Commission',
      gameConfig: 'Game Config',
      peiwanTypeConfig: 'Companion Types',
      vipLevelConfig: 'VIP Levels',
      discountConfig: 'Discounts',
      withdrawConfig: 'Withdrawal Config',
      tokenManagement: 'Token Mgmt',
      departmentConfig: 'Departments',
      gameDict: 'Game Dictionary',
      peiwanType: 'Companion Types'
    },
    config: {
      defaultCommission: 'Default Commission Config',
      companionOrder: 'Companion Order Commission',
      boostOrder: 'Boost Order Commission',
      giftOrder: 'Gift Order Commission',
      withdrawFreezeDays: 'Withdrawal Freeze Days',
      days: 'days',
      lastUpdate: 'Last update: ',
      operator: 'Operator: ',
      commissionHint: 'After update, new users will inherit this default commission. Existing users are not affected.',
      withdrawHint: 'Set how many days companions must wait after order approval before requesting withdrawal.'
    },
    batch: {
      title: 'Batch Adjust Commission',
      warning: 'Batch adjustment will overwrite all users\' commission rates, including manually adjusted ones.',
      applyAll: 'Apply to All'
    },
    token: {
      title: 'Token Management',
      hint: 'Tokens are used for user registration verification. Old tokens will be invalidated immediately after reset.',
      status: 'Current status: ',
      configured: 'Configured',
      notConfigured: 'Not configured',
      randomGenerate: 'Generate Random Token',
      newToken: 'New token: ',
      copyHint: 'Please copy and save this token immediately. It cannot be viewed again after closing!',
      manualSet: 'Manual Token Setup:',
      placeholder: 'Enter new token (min 6 chars)',
      update: 'Update',
      minLengthError: 'Token must be at least 6 characters'
    },
    department: {
      title: 'Department Config',
      add: 'Add Department',
      edit: 'Edit Department',
      save: 'Save Config',
      code: 'Department Code',
      name: 'Department Name',
      codePlaceholder: 'Enter department code',
      namePlaceholder: 'Enter department name',
      hint: 'Department config is used for user management and order assignment. Please modify with caution.',
      emptyError: 'Department code and name cannot be empty',
      duplicateError: 'Department code already exists'
    },
    vipLevel: {
      title: 'VIP Level',
      add: 'Add VIP Level',
      edit: 'Edit VIP Level',
      columns: {
        id: 'VIP Level ID',
        name: 'VIP Level Name',
        key: 'VIP Level Key',
        type: 'VIP Level Type',
        discount: 'Discount %',
        operation: 'Operation'
      },
      form: {
        name: 'VIP Level Name',
        key: 'VIP Level Key',
        type: 'VIP Level Type',
        description: 'VIP Level Description',
        discount: 'Discount %'
      },
      placeholder: {
        name: 'Enter VIP level name',
        key: 'Enter VIP level key',
        type: 'Enter VIP level type',
        description: 'Enter VIP level description',
        discount: 'Enter discount percentage'
      }
    },
    discount: {
      title: 'Discount Config',
      add: 'Add Discount',
      edit: 'Edit Discount',
      columns: {
        id: 'Discount ID',
        name: 'Discount Name',
        value: 'Discount %',
        operation: 'Operation'
      },
      form: {
        name: 'Discount Name',
        value: 'Discount %'
      },
      placeholder: {
        name: 'Enter discount name',
        value: 'Enter discount percentage'
      }
    },
    messages: {
      confirmBatchEdit: 'Confirm Batch Edit',
      confirmBatchEditContent: 'This will overwrite all users\' commission rates (including manually adjusted ones). Continue?',
      confirmOverwrite: 'Confirm Overwrite',
      batchEditSuccess: 'Batch edit successful, {affected} users affected',
      confirmResetToken: 'Confirm Reset Token',
      confirmResetTokenContent: 'This will generate a new registration token. The old token will be invalidated immediately. Continue?',
      confirmReset: 'Confirm Reset',
      tokenResetSuccess: 'Token reset. Please copy the new token',
      confirmUpdateToken: 'Confirm Update Token',
      confirmUpdateTokenContent: 'This will update the registration token. The old token will be invalidated immediately. Continue?',
      confirmUpdate: 'Confirm Update',
      tokenUpdateSuccess: 'Token updated',
      tokenCopied: 'Token copied to clipboard',
      commissionUpdated: 'Commission config updated',
      withdrawFreezeUpdated: 'Withdrawal freeze days updated',
      departmentSaved: 'Department config saved',
      confirmDeleteDepartment: 'Confirm Delete',
      confirmDeleteDepartmentContent: 'Are you sure you want to delete this department?'
    },
    buttons: {
      save: 'Save',
      copy: 'Copy'
    }
  },
  withdraw: {
    title: 'Withdrawal Management',
    columns: {
      playerName: 'Companion Name',
      amount: 'Withdrawal Amount',
      orderType: 'Order Type',
      department: 'Department',
      project: 'Project',
      payee: 'Payee',
      payeePhone: 'Payee Phone',
      payeeWechat: 'Payee WeChat',
      wechatQrcode: 'WeChat QR Code',
      alipayQrcode: 'Alipay QR Code',
      status: 'Review Status',
      createTime: 'Initiated At',
      reviewTime: 'Reviewed At',
      operation: 'Operation'
    },
    search: {
      playerName: 'Companion Nickname',
      orderType: 'Order Type',
      status: 'Review Status',
      department: 'Department',
      createTime: 'Initiated At',
      reviewTime: 'Reviewed At'
    },
    placeholder: {
      playerName: 'Enter companion nickname',
      orderType: 'Select order type',
      status: 'Select review status',
      department: 'Select department'
    },
    detail: {
      playerUsername: 'Companion/Boost Username',
      playerNickname: 'Companion/Boost Name',
      amount: 'Withdrawal Amount',
      status: 'Withdrawal Status',
      createTime: 'Withdrawal Request Time',
      reviewer: 'Reviewer',
      reviewRemark: 'Review Remark',
      reviewTime: 'Review Time',
      orderType: 'Order Type'
    },
    buttons: {
      review: 'Review',
      pass: 'Approve',
      reject: 'Reject'
    },
    messages: {
      confirmPass: 'Confirm approve?',
      confirmReject: 'Confirm reject?'
    }
  },
  user: {
    title: 'User Management',
    columns: {
      nickname: 'Nickname',
      username: 'Username',
      gender: 'Gender',
      avatar: 'Avatar',
      role: 'Role',
      department: 'Department',
      balance: 'Wallet Balance',
      withdrawableBalance: 'Withdrawable Balance',
      companionCommission: 'Companion Commission',
      boostCommission: 'Boost Commission',
      giftCommission: 'Gift Commission',
      phone: 'Phone',
      wechat: 'WeChat',
      alipay: 'Alipay',
      wechatQrcode: 'WeChat QR Code',
      alipayQrcode: 'Alipay QR Code',
      email: 'Email',
      qq: 'QQ',
      birthday: 'Birthday',
      bio: 'Bio',
      lastLogin: 'Last Login',
      status: 'Status',
      operation: 'Operation'
    },
    search: {
      nickname: 'Nickname'
    },
    placeholder: {
      nickname: 'Enter nickname'
    },
    buttons: {
      add: 'Add User',
      export: 'Export',
      editCommission: 'Edit Commission',
      edit: 'Edit',
      resetPassword: 'Reset Password',
      leave: 'Leave Shop'
    },
    tabs: {
      employee: 'Employee',
      companion: 'Companion/Boost'
    },
    messages: {
      confirmDelete: 'Confirm delete?',
      noPermission: 'No permission',
      uploadSuccess: 'Upload successful!',
      uploadFailed: 'Upload failed'
    },
    form: {
      username: 'Username',
      password: 'Password',
      newPassword: 'New Password',
      nickname: 'Nickname',
      gender: 'Gender',
      role: 'Role',
      department: 'Department',
      phone: 'Phone',
      email: 'Email',
      qq: 'QQ',
      bio: 'Bio',
      status: 'Status',
      authInfo: 'Auth Info',
      realName: 'Real Name',
      idCardNo: 'ID Card No',
      authPhone: 'Phone',
      wechat: 'WeChat',
      alipay: 'Alipay',
      location: 'Address',
      wechatQrcode: 'WeChat QR Code',
      alipayQrcode: 'Alipay QR Code',
      walletBalance: 'Wallet Balance',
      companionCommission: 'Companion Commission',
      boostCommission: 'Boost Commission',
      giftCommission: 'Gift Commission'
    },
    formPlaceholder: {
      username: 'Enter username',
      password: 'Enter password',
      newPassword: 'Enter new password',
      nickname: 'Enter nickname',
      gender: 'Select gender',
      role: 'Select role',
      department: 'Select department',
      phone: 'Enter phone',
      email: 'Enter email',
      qq: 'Enter QQ',
      bio: 'Enter bio',
      realName: 'Enter real name',
      idCardNo: 'Enter ID card number',
      authPhone: 'Enter phone',
      wechat: 'Enter WeChat',
      alipay: 'Enter Alipay account',
      location: 'Enter address',
      walletBalance: 'Enter wallet balance',
      companionCommission: 'Enter companion commission',
      boostCommission: 'Enter boost commission',
      giftCommission: 'Enter gift commission'
    },
    gender: {
      female: 'Female',
      male: 'Male'
    },
    upload: {
      upload: 'Upload'
    },
    switch: {
      disable: 'Disable',
      enable: 'Enable'
    }
  },
  client: {
    title: 'Client Management',
    columns: {
      customerId: 'Customer ID',
      name: 'Customer Name',
      gender: 'Gender',
      vipLevel: 'VIP Level',
      balance: 'Balance',
      totalSpent: 'Total Spent',
      wechat: 'WeChat',
      phone: 'Phone',
      operation: 'Operation'
    },
    search: {
      customerId: 'Customer ID',
      name: 'Customer Name',
      gender: 'Gender',
      vipLevel: 'VIP Level',
      phone: 'Phone',
      wechat: 'WeChat',
      status: 'Status',
      balanceLte: 'Balance ≤',
      balanceGte: 'Balance ≥',
      totalSpentLte: 'Total Spent ≤',
      totalSpentGte: 'Total Spent ≥'
    },
    placeholder: {
      customerId: 'Enter customer ID',
      name: 'Enter customer name',
      gender: 'Select gender',
      vipLevel: 'Select VIP level',
      phone: 'Enter phone',
      wechat: 'Enter WeChat'
    },
    buttons: {
      add: 'Add Customer',
      charge: 'Charge',
      export: 'Export'
    },
    form: {
      name: 'Customer Name',
      gender: 'Gender',
      vipLevel: 'VIP Level',
      wechat: 'WeChat',
      phone: 'Phone',
      balance: 'Balance',
      totalSpent: 'Total Spent',
      chargeAmount: 'Charge Amount',
      chargeType: 'Charge Type'
    },
    formPlaceholder: {
      name: 'Enter customer name',
      gender: 'Select gender',
      vipLevel: 'Select VIP level',
      wechat: 'Enter WeChat',
      phone: 'Enter phone',
      balance: 'Enter balance',
      totalSpent: 'Enter total spent',
      chargeAmount: 'Enter charge amount',
      chargeType: 'Select charge type'
    },
    gender: {
      female: 'Female',
      male: 'Male'
    }
  },
  order: {
    title: 'Order Management',
    columns: {
      orderId: 'Order ID',
      customerId: 'Customer ID',
      customerName: 'Customer Name',
      bossName: 'Boss Name',
      companionType: 'Companion Type',
      companionServer: 'Companion Server',
      duration: 'Duration/Rounds',
      startTime: 'Start Time',
      endTime: 'End Time',
      unitPrice: 'Unit Price (¥)',
      totalPrice: 'Total Price (¥)',
      department: 'Department',
      dispatcher: 'Dispatcher',
      status: 'Order Status',
      wins: 'Wins',
      losses: 'Losses',
      battleScreenshot: 'Battle Screenshot',
      remark: 'Remark',
      orderTime: 'Order Time',
      reviewTime: 'Review Time',
      withdrawApplyTime: 'Withdraw Apply Time',
      withdrawPassTime: 'Withdraw Pass Time',
      operation: 'Operation'
    },
    search: {
      orderId: 'Order ID',
      customerId: 'Customer ID',
      dispatcher: 'Dispatcher',
      status: 'Order Status',
      orderDate: 'Order Date'
    },
    placeholder: {
      orderId: 'Enter order ID',
      customerId: 'Enter customer ID',
      dispatcher: 'Select dispatcher',
      status: 'Select order status',
      orderDate: 'Select order date'
    },
    buttons: {
      add: 'Add',
      viewDetail: 'View Detail',
      withdraw: 'Withdraw',
      cancel: 'Cancel'
    },
    messages: {
      withdrawSuccess: 'Withdrawal request submitted!',
      confirmCancel: 'Confirm cancel?'
    },
    expand: 'Expand',
    collapse: 'Collapse',
    noData: 'N/A',
    form: {
      companionType: 'Companion Content',
      startTime: 'Service Start Time',
      endTime: 'Service End Time',
      duration: 'Duration/Rounds',
      gameServer: 'Game Server',
      bossName: 'Boss Name',
      customer: 'Customer',
      dispatcher: 'Dispatcher',
      department: 'Department',
      discount: 'Discount',
      hourlyRate: 'Hourly Rate',
      totalPrice: 'Total Price',
      wins: 'Wins',
      losses: 'Losses',
      battleScreenshot: 'Battle Screenshot',
      remark: 'Remark',
      isFailed: 'Is Failed',
      reviewResult: 'Review Result',
      reviewRemark: 'Review Remark'
    },
    formPlaceholder: {
      companionType: 'Select companion content',
      startTime: 'Select start time',
      endTime: 'Select end time',
      duration: 'Enter duration',
      gameServer: 'Select game server',
      bossName: 'Enter boss name',
      customer: 'Select customer',
      dispatcher: 'Select dispatcher',
      department: 'Select department',
      discount: 'Select discount',
      hourlyRate: 'Enter hourly rate',
      totalPrice: 'Enter total price',
      wins: 'Enter wins',
      losses: 'Enter losses',
      reviewResult: 'Select review result'
    },
    review: {
      pass: 'Pass',
      reject: 'Reject'
    },
    upload: {
      clickToUpload: 'Click to upload',
      preview: 'Preview'
    },
    player: {
      username: 'Player Username',
      nickname: 'Player Nickname'
    },
    durationUnit: 'h/round',
    yes: 'Yes',
    no: 'No'
  },
  role: {
    title: 'Role Management',
    roleName: 'Role Name',
    roleDesc: 'Role Description',
    enabled: 'Enabled',
    columns: {
      id: 'ID',
      name: 'Role Name',
      description: 'Description',
      userCount: 'User Count',
      createTime: 'Created At',
      status: 'Status',
      operation: 'Operation'
    },
    formPlaceholder: {
      name: 'Enter role name',
      description: 'Enter role description'
    }
  },
  billing: {
    title: 'Billing Management'
  },
  dailian: {
    title: 'Boosting Management',
    columns: {
      orderId: 'Order ID',
      customerId: 'Customer ID',
      customerName: 'Customer Name',
      bossName: 'Boss Name',
      gameServer: 'Game Server',
      startLevel: 'Start Level',
      endLevel: 'End Level',
      finishScreenshot: 'Finish Screenshot',
      totalPrice: 'Total Price (¥)',
      department: 'Department',
      dispatcher: 'Dispatcher',
      status: 'Order Status',
      wins: 'Wins',
      losses: 'Losses',
      battleScreenshot: 'Battle Screenshot',
      remark: 'Remark',
      orderTime: 'Order Time',
      reviewTime: 'Review Time',
      withdrawApplyTime: 'Withdraw Apply Time',
      withdrawPassTime: 'Withdraw Pass Time',
      operation: 'Operation'
    },
    search: {
      orderId: 'Order ID',
      customerId: 'Customer ID',
      dispatcher: 'Dispatcher',
      status: 'Order Status',
      orderDate: 'Order Date'
    },
    placeholder: {
      orderId: 'Enter order ID',
      customerId: 'Enter customer ID',
      dispatcher: 'Select dispatcher',
      status: 'Select order status',
      orderDate: 'Select order date'
    },
    buttons: {
      add: 'Add',
      viewDetail: 'View Detail',
      withdraw: 'Withdraw',
      cancel: 'Cancel'
    },
    messages: {
      withdrawSuccess: 'Withdrawal request submitted!',
      confirmCancel: 'Confirm cancel?'
    },
    expand: 'Expand',
    collapse: 'Collapse',
    form: {
      gameServer: 'Game Server',
      bossName: 'Boss Name',
      customer: 'Customer',
      department: 'Department',
      dispatcher: 'Dispatcher',
      startLevel: 'Start Level',
      endLevel: 'End Level',
      finishScreenshot: 'Finish Screenshot',
      totalPrice: 'Total Price',
      wins: 'Wins',
      losses: 'Losses',
      battleScreenshot: 'Battle Screenshot',
      remark: 'Remark',
      isFailed: 'Is Failed',
      reviewResult: 'Review Result',
      reviewRemark: 'Review Remark'
    },
    formPlaceholder: {
      gameServer: 'Select game server',
      bossName: 'Enter boss name',
      customer: 'Select customer',
      department: 'Select department',
      dispatcher: 'Select dispatcher',
      startLevel: 'Enter start level',
      endLevel: 'Enter end level',
      totalPrice: 'Enter total price',
      wins: 'Enter wins',
      losses: 'Enter losses',
      reviewResult: 'Select review result'
    },
    player: {
      username: 'Booster Username',
      nickname: 'Booster Nickname'
    },
    upload: {
      clickToUpload: 'Click to upload',
      preview: 'Preview'
    },
    review: {
      pass: 'Pass',
      reject: 'Reject'
    },
    yes: 'Yes',
    no: 'No'
  },
  gift: {
    title: 'Gift Management',
    columns: {
      orderId: 'Order ID',
      customerId: 'Customer ID',
      customerName: 'Customer Name',
      bossName: 'Boss Name',
      giftAmount: 'Gift Amount (¥)',
      dispatcher: 'Dispatcher',
      department: 'Department',
      status: 'Order Status',
      screenshot: 'Screenshot',
      remark: 'Remark',
      orderTime: 'Order Time',
      reviewTime: 'Review Time',
      withdrawApplyTime: 'Withdraw Apply Time',
      withdrawPassTime: 'Withdraw Pass Time',
      operation: 'Operation'
    },
    search: {
      orderId: 'Order ID',
      customerId: 'Customer ID',
      dispatcher: 'Dispatcher',
      status: 'Order Status',
      orderDate: 'Order Date'
    },
    placeholder: {
      orderId: 'Enter order ID',
      customerId: 'Enter customer ID',
      dispatcher: 'Select dispatcher',
      status: 'Select order status',
      orderDate: 'Select order date'
    },
    buttons: {
      add: 'Add',
      viewDetail: 'View Detail',
      withdraw: 'Withdraw',
      cancel: 'Cancel'
    },
    messages: {
      withdrawSuccess: 'Withdrawal request submitted!',
      confirmCancel: 'Confirm cancel?'
    },
    expand: 'Expand',
    collapse: 'Collapse',
    form: {
      bossName: 'Boss Name',
      customer: 'Customer',
      department: 'Department',
      dispatcher: 'Dispatcher',
      totalPrice: 'Total Price',
      screenshot: 'Screenshot',
      remark: 'Remark',
      reviewResult: 'Review Result',
      reviewRemark: 'Review Remark'
    },
    formPlaceholder: {
      bossName: 'Enter boss name',
      customer: 'Select customer',
      department: 'Select department',
      dispatcher: 'Select dispatcher',
      totalPrice: 'Enter total price',
      reviewResult: 'Select review result'
    },
    player: {
      username: 'Player Username',
      nickname: 'Player Nickname'
    },
    upload: {
      clickToUpload: 'Click to upload',
      preview: 'Preview'
    },
    review: {
      pass: 'Pass',
      reject: 'Reject'
    }
  },
  rankList: {
    title: 'Rankings',
    date: 'Date',
    datePlaceholder: 'Select date',
    export: 'Export',
    participants: '{count} participants',
    myRank: 'Your current rank',
    rankPosition: '#{rank}',
    myValue: ', your {label} is',
    noRank: 'No ranking yet',
    male: 'Male',
    female: 'Female',
    overall: 'Overall',
    exportSuccess: 'Export task submitted, check progress in Download Center',
    rankSuffix: ' Ranking',
    rank: 'Rank',
    nickname: 'Nickname',
    winRate: 'Win Rate',
    wins: 'W{count}',
    losses: 'L{count}',
    reset: 'Reset'
  },
  downloadCenter: {
    title: 'Download Center',
    refresh: 'Refresh',
    createTime: 'Create Time:',
    search: 'Search',
    reset: 'Reset',
    autoRefreshHint: 'Tasks are processing, page will auto-refresh...',
    columns: {
      taskName: 'Task Name',
      type: 'Type',
      status: 'Status',
      dataCount: 'Count',
      creator: 'Creator',
      createTime: 'Created At',
      finishTime: 'Finished At',
      operation: 'Operation'
    },
    status: {
      pending: 'Pending',
      processing: 'Processing',
      success: 'Success',
      failed: 'Failed'
    },
    messages: {
      downloadUrlFailed: 'Failed to get download URL',
      downloadFailed: 'Download failed'
    },
    buttons: {
      download: 'Download'
    },
    noData: 'No Data',
    processing: 'Processing...',
    exportFailed: 'Export Failed',
    ranges: {
      today: 'Today',
      thisWeek: 'This Week',
      lastWeek: 'Last Week',
      thisMonth: 'This Month',
      lastMonth: 'Last Month',
      last3Months: 'Last 3 Months',
      last6Months: 'Last 6 Months'
    }
  },
  personal: {
    title: 'Profile',
    overview: 'Overview',
    changeAvatar: 'Change Avatar',
    resetPassword: 'Reset Password',
    form: {
      oldPassword: 'Old Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password'
    },
    placeholder: {
      oldPassword: 'Enter old password',
      newPassword: 'Enter new password',
      confirmPassword: 'Enter new password again'
    },
    messages: {
      uploadImageOnly: 'Please upload image files only! Please delete the current file manually.',
      uploadJpgPng: 'Please upload jpg/jpeg or png images only! Please delete the current file manually.',
      uploadSizeLimit: 'File size cannot exceed 10MB! Please delete the current file manually.',
      uploadSuccess: 'Upload successful!',
      passwordMismatch: 'New passwords do not match! Please try again.',
      resetSuccess: 'Password reset successful!'
    }
  },
  dataScreen: {
    title: 'Data Dashboard',
    noPermission: 'You do not have permission to access the data dashboard',
    sections: {
      companionOrderRank: 'Companion Order Rank',
      companionAmountRank: 'Companion Amount Rank',
      giftPopularityRank: 'Gift Popularity Rank',
      todayRevenue: 'Today Revenue',
      realTimeOrderAmount: 'Real-time Order Amount',
      realTimeComplaints: 'Real-time Complaints',
      customerConsumeRank: 'Customer Consume Rank',
      companionTypeDistribution: 'Companion Type Distribution',
      giftIncomeRank: 'Gift Income Rank'
    }
  },
  dict: {
    title: 'Dictionary Management'
  },
  system: {
    title: 'System Management'
  },
  log: {
    title: 'Log Management'
  },
  registerReview: {
    title: 'Registration Review',
    columns: {
      username: 'Username',
      nickname: 'Nickname',
      phone: 'Phone',
      wechat: 'WeChat',
      alipay: 'Alipay',
      realName: 'Real Name',
      idCard: 'ID Card',
      location: 'Location',
      requestTime: 'Request Time',
      requestStatus: 'Request Status',
      operation: 'Operation'
    },
    search: {
      status: 'Request Status'
    },
    modal: {
      title: 'Review Registration',
      basicInfo: 'Basic Info',
      identityInfo: 'Identity Info',
      role: 'Applied Role',
      reviewResult: 'Review Result',
      reviewPlaceholder: 'Select review result'
    },
    buttons: {
      review: 'Review',
      submit: 'Submit',
      cancel: 'Cancel'
    }
  },
  afterSale: {
    title: 'After-Sales Management'
  },
  formRules: {
    required: 'Please {action} {label}',
    input: 'enter',
    select: 'select',
    phone: 'Please enter a valid phone number',
    idCard: 'Please enter a valid ID card number',
    positiveNumber: '{label} cannot be negative',
    rangeNumber: '{label} must be between {min}-{max}'
  },
  errors: {
    updatePermission: 'Update Permission'
  }
}
